module.exports = __webpack_public_path__ + "/images/e911ecf381da664d9285b7669dc898da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/kids.png
// module id = 794
// module chunks = 0